import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';
import PropTypes from 'prop-types';

import { toMoment } from 'features/timesheets/util';

import { cxHelpers } from 'util/className';

const { cx } = cxHelpers('IndividualBreak');

import { BLANK_HOURS } from 'features/timesheets/TimesheetsPage/TimecardModal/constants';

function formatTime(timeString) {
  return toMoment(timeString).format('h:mm A');
}

function getTimeRange(timebreak, inProgress, onEndBreak) {
  const endAt = timebreak.get('end_at');

  let endAtStr;
  if (endAt) {
    endAtStr = <Text>{formatTime(endAt)}</Text>;
  } else {
    endAtStr = inProgress ? (
      <Button variant="tertiary" onClick={onEndBreak}>
        <Text i18n="timecard_modal_v3.timebreaks_section.end_break" />
      </Button>
    ) : (
      BLANK_HOURS
    );
  }

  return (
    <Box row vcenter>
      <Text>{formatTime(timebreak.get('start_at'))}</Text>
      <Box vcenter p={4} pt={2}>
        -
      </Box>
      {endAtStr}
    </Box>
  );
}

const IndividualBreak = ({
  timebreak,
  breakDuration,
  inProgress,
  onEndBreak,
}) => {
  const isOpenBreak = inProgress && !timebreak.get('end_at');

  return (
    <Box key={timebreak.get('id')} className={cx()} row vcenter mb={4}>
      <Box>
        <Text color={isOpenBreak ? 'green300' : 'mono900'}>
          {breakDuration}
        </Text>
      </Box>

      <Box ml={8} mr={4}>
        <Text>{' • '}</Text>
      </Box>

      <Box>
        {timebreak.get('employee_waived') && (
          <Text
            color="mono900"
            i18n="timecard_modal_v3.timebreaks_section.break_waived"
          />
        )}
        {!timebreak.get('employee_waived') && (
          <Text color="mono900">
            {getTimeRange(timebreak, inProgress, onEndBreak)}
          </Text>
        )}
      </Box>
    </Box>
  );
};

IndividualBreak.propTypes = {
  timebreak: ImmutablePropTypes.map.isRequired,
  breakDuration: PropTypes.string.isRequired,
  inProgress: PropTypes.bool,
  onEndBreak: PropTypes.func.isRequired,
};

export default IndividualBreak;
